/* @flow */

import * as React from 'react';
import { observable } from 'mobx';
import { inject, observer } from 'mobx-react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

//----------------------------------------------------------------------//
// MATERIAL UI                                                          //
//----------------------------------------------------------------------//

import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Typography from '@material-ui/core/Typography';

//----------------------------------------------------------------------//
//----------------------------------------------------------------------//

import type { TypeManufacturersProductsStore } from 'stores/ManufacturersProductsStore.js';

import Loading from 'components/Loading/Loading';

import finderColumns from 'components/FinderColumns/FinderColumns';

import Activity from 'components/Activity/Activity';

import ProductDetails from '../ProductDetails/ProductDetails';

import styles from '../ManufacturerDetailsActivity/ManufacturerDetailsActivity.module.scss';
import { generateUrl, product } from 'api/routes';

type TypeProps = {
  manufacturersProductsStore: TypeManufacturersProductsStore,
} & TranslatorProps;

@translate()
@inject('manufacturersProductsStore', 'assetStore')
@finderColumns
@observer
export default class ProductDetailsActivity extends React.Component<*> {
  @observable value: number = 0;

  handleTabChange = (e: SyntheticInputEvent<*>, v: number) => {
    this.value = v;
  };

  render() {
    const { manufacturersProductsStore, t }: TypeProps = this.props;

    const value: number = this.value;

    if (!manufacturersProductsStore.products.length) {
      return null;
    }

    if (!manufacturersProductsStore.selectedProductId) {
      return (
        <div className={styles['finder-column-empty']}>
          <p>{t('general:products.messages.select')}</p>
        </div>
      );
    }

    if (manufacturersProductsStore.loadingSelectedProduct) {
      return <Loading />;
    }

    return (
      <div className={styles['manufacturer-detail']}>
        <Typography variant="title" color="inherit">
          {manufacturersProductsStore.selectedProduct.model}
        </Typography>
        <Tabs value={value} onChange={this.handleTabChange} fullWidth={true}>
          <Tab label={t('general:detail_plural')} />
          <Tab label={t('general:activity')} />
        </Tabs>
        {value === 0 && (
          <TabContainer>
            <ProductDetails />
          </TabContainer>
        )}
        {value === 1 && (
          <TabContainer>
            <Activity
              url={generateUrl(product.activity, [manufacturersProductsStore.selectedProductId])}
              allowFilter={true}
            />
          </TabContainer>
        )}
      </div>
    );
  }
}

class TabContainer extends React.Component<*> {
  render() {
    return <div className={styles['tab-container']}>{this.props.children}</div>;
  }
}
